import apiFinancial from "../config/api_financial";

// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

export function generateConciliationTransactionsMatch(payload) {
  const {
    groupId,
    farmId,
    withoutPagination,
    search,
    page,
    size,
    sort,
    signal,
  } = payload;

  if (withoutPagination) {
    return apiFinancial.get(
      `/bovexo/${groupId}/farms/${farmId}/conciliation/transactions/match?withoutPagination=true`,
      getHeaders(false, signal),
    );
  }

  const orderS =
    Object.entries(sort).length > 0 && sort.order
      ? sort.order === "descend"
        ? "DESC"
        : sort.order === "ascend"
          ? "ASC"
          : "DESC"
      : "DESC";
  const requestParams = `page=${page > 0 ? page - 1 : 0}&size=${size ?? 10}${
    sort && Object.entries(sort).length > 0 && sort.order
      ? `&sort=${sort.field}&direction=${orderS}`
      : ""
  }${search && search !== "" ? `&search=${search}` : ""}`;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/conciliation/transactions/match?${requestParams}`,
    getHeaders(false, signal),
  );
}

export function pageFinancialTransactionsInstallmetnsForConciliation(payload) {
  const { groupId, farmId, search, page, size, sort, idsNotIncluded, signal } =
    payload;

  const orderS =
    Object.entries(sort).length > 0 && sort.order
      ? sort.order === "descend"
        ? "DESC"
        : sort.order === "ascend"
          ? "ASC"
          : "DESC"
      : "DESC";
  const requestParams = `page=${page > 0 ? page - 1 : 0}&size=${size ?? 10}${
    sort && Object.entries(sort).length > 0 && sort.order
      ? `&sort=${sort.field}&direction=${orderS}`
      : ""
  }${search && search !== "" ? `&search=${search}` : ""}`;

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/conciliation/transactions/installments/search?${requestParams}`,
    idsNotIncluded,
    getHeaders(false, signal),
  );
}

export function saveConciliation(payload) {
  const { groupId, farmId, data, signal } = payload;

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/conciliations`,
    data,
    getHeaders(false, signal),
  );
}

export function saveConciliationTransactions(payload) {
  const { groupId, farmId, data, signal } = payload;

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/conciliation/transactions`,
    data,
    getHeaders(false, signal),
  );
}

export function removeConciliation(payload) {
  const { groupId, farmId, data, signal } = payload;

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/conciliation/transactions/remove`,
    data,
    getHeaders(false, signal),
  );
}
